// Localization helpers: date format + measurement per market (sections 26/27).
const DATE_LOCALE = { BR: "pt-BR", PT: "pt-PT", US: "en-US", ES: "es-ES", FR: "fr-FR", IT: "it-IT" };

export function formatDate(date, country = "BR") {
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d)) return "";
  const locale = DATE_LOCALE[country] || "pt-BR";
  return new Intl.DateTimeFormat(locale, { day: "2-digit", month: "2-digit", year: "numeric" }).format(d);
}

export function formatDateLong(date, country = "BR") {
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d)) return "";
  const locale = DATE_LOCALE[country] || "pt-BR";
  return new Intl.DateTimeFormat(locale, { day: "numeric", month: "long", year: "numeric" }).format(d);
}

export function currencyForCountry(config, country) {
  const c = config?.countries?.find((x) => x.code === country);
  return c?.currency || "BRL";
}

export function measurementForCountry(config, country) {
  return config?.measurements?.[country] || "metric";
}
